import { Amplify, API } from 'aws-amplify';
import { athleteByEmail, coachByEmail, listClubs } from '../graphql/queries';

import React, { useReducer } from 'react';
import { createAthlete, createCoach } from '../graphql/mutations';

Amplify.configure({
    aws_appsync_graphqlEndpoint: process.env.REACT_APP_BACKEND_aws_appsync_graphqlEndpoint,
    aws_appsync_region: process.env.REACT_APP_BACKEND_aws_appsync_region,
    aws_appsync_authenticationType: process.env.REACT_APP_BACKEND_aws_appsync_authenticationType,
    aws_appsync_apiKey: process.env.REACT_APP_BACKEND_aws_appsync_apiKey,
    Auth:{
      identityPoolId: process.env.REACT_APP_BACKEND_identityPoolId,
      region: process.env.REACT_APP_BACKEND_region,
      userPoolId : process.env.REACT_APP_BACKEND_userPoolId,
      userPoolWebClientId : process.env.REACT_APP_BACKEND_userPoolWebClientId,
    },
    Storage :{
      AWSS3 : {
        bucket: process.env.REACT_APP_BACKEND_aws_user_files_s3_bucket,
        region: process.env.REACT_APP_BACKEND_aws_user_files_s3_bucket_region
      }
    }
});
const Context = React.createContext();
const _state = {
  clubs: [],
};

function Reducer(state, { type, data }) {
  switch (type) {
    case 'SET_CLUBS': {
      return {
        ...state,
        clubs: data,
      };
    }
    default:
      break;
  }
}

const Provider = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, _state);
  async function getClubs() {
    try {
      const {
        data: {
          listClubs: { items: clubs },
        },
      } = await API.graphql({ query: listClubs, authMode: 'API_KEY' });
      clubs.sort((a,b)=>a.name < b.name ? -1 : 1);
      dispatch({ type: 'SET_CLUBS', data: clubs });
    } catch (err) {
      console.log(err);
    }
  }
  async function addAthlete(athleteDetails) {
    return await API.graphql({
      query: createAthlete,
      authMode: 'API_KEY',
      variables: { input: athleteDetails },
    });
  }
  async function addCoach(coachDetails) {
    return await API.graphql({
      query: createCoach,
      authMode: 'API_KEY',
      variables: { input: coachDetails },
    });
  }
  async function coachEmailExists(email){
    const { data : { coachByEmail : { items }} } = await API.graphql({
      query : coachByEmail,
      authMode: 'API_KEY',
      variables: {email}  ,
    });
    return items;
  }
  async function athleteEmailExists(email){
    const { data : { athleteByEmail : { items }} } = await API.graphql({
      query : athleteByEmail,
      authMode: 'API_KEY',
      variables: {email}  ,
    });
    return items;
  }
  return (
    <Context.Provider value={{ state, getClubs, addAthlete , addCoach , athleteEmailExists,coachEmailExists}}>
      {children}
    </Context.Provider>
  );
};
export { Context, Provider };
